export const getStoreUsers = state => state.UserReducer.users
export const getStoreTotal = state => state.UserReducer.totalUsers